import { LOAD_DEVICE_TYPES_SUCCESS } from 'actions/devices';

export const defaultState = {
  data: [],
};

export default function deviceNames(state = defaultState, action) {
  switch (action.type) {
    case LOAD_DEVICE_TYPES_SUCCESS: {
      const transformedDeviceTypes = Object.values(action.payload);
      return {
        ...state,
        data: transformedDeviceTypes,
      };
    }
    default:
      return state;
  }
}
